import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import React, { useState, Fragment } from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'

import RegionChooser from '../RegionChooser'
import { useRegion } from '../RegionChooser/hook'

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    regionIcon: {
      padding: 12,
    },
    regionAvatar: {
      height: 24,
      width: 24,
    },
  })
})

interface IProps {}

const RegionChooserButton = (props: IProps) => {
  const { ready: rReady, flagImage } = useRegion()
  const { t } = useTranslation('Header')

  const classes = useStyles()
  const [showPortal, setShowPortal] = useState(false)
  const portal: HTMLDivElement = document.querySelector('.si-portal')

  return (
    <Fragment>
      {showPortal
        ? ReactDOM.createPortal(
            <RegionChooser
              isOpen={true}
              onClose={() => {
                setShowPortal(false)
              }}
            />,
            portal
          )
        : null}
      <IconButton
        className={classes.regionIcon}
        aria-label={t('change-region-open')}
        title={t('change-region-open')}
        onClick={() => {
          setShowPortal(true)
        }}
      >
        {rReady ? (
          <Avatar className={classes.regionAvatar} src={flagImage} />
        ) : null}
      </IconButton>
    </Fragment>
  )
}

export default RegionChooserButton
